const $ = window.jQuery || {};

class PartnerShop {
  constructor() {
    this.$categoryButtons = $(
      ".lightglobal-forward--partner-shops__category-btn"
    );
    this.$shopItems = $(".lightglobal-forward--partner-shops__item");

    this.$categoryButtons.on("click", (e) => {
      // const category = $(this).attr("data-category");
      const category = e.target.getAttribute("data-category");

      this.$categoryButtons.removeClass("active");
      $(this).addClass("active");

      if (category === "all") {
        this.$shopItems.show();
      } else {
        this.$shopItems.each(function () {
          const $item = $(this);
          const itemCategories = $item.attr("data-categories").split(" ");

          if (itemCategories.includes(category)) {
            $item.show();
          } else {
            $item.hide();
          }
        });
      }
    });
  }
}

export default PartnerShop;
